export default {
  portability: false,
  addicionalNumbers: [],
  availableNumbers: [],
  lastSessionId: null,
  chosenNumber: null,
  paymentInfo: {
    entity: null,
    ref: null,
    total: null
  },
  portabilityInfo: {
    isCVPValid: null,
    isOTPValid: false,
    otpTries: 3,
    cvp: '',
    provider: '',
    sentSMS: false,
    otp: '',
    date: '',
    isNumberValid: null,
    showDate: false
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/movel/state.js